import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Directive({
    selector: '[appInvalidFormScroll]',
    standalone: false
})
export class InvalidFormScrollDirective {
	
	@Input('appInvalidFormScroll') appInvalidFormScroll: HTMLFormElement;
	@Input('appInvalidFormScrollFormGroupRef') appInvalidFormScrollFormGroupRef: UntypedFormGroup;
	
	constructor(
		private elementRef: ElementRef<HTMLElement>,
		@Optional() private formGroupDirective: FormGroupDirective
	) { }

	@HostListener('ngSubmit') onSubmit() {
		if (this.elementRef.nativeElement.tagName === 'FORM') {
			if (this.formGroupDirective.control.invalid) {
				this.scrollToFirstInvalidControl(this.elementRef.nativeElement);
			}
		}
	}

	@HostListener('click') onClick() {
		if (this.elementRef.nativeElement.tagName === 'BUTTON') {
			if (this.appInvalidFormScrollFormGroupRef.invalid) {
				this.scrollToFirstInvalidControl(this.appInvalidFormScroll);
			}
		}
	}

	private scrollToFirstInvalidControl(form: HTMLElement) {
		const firstInvalidControl: HTMLElement = form.querySelector('.ng-invalid');
	
		if (firstInvalidControl) {
			const inputElement = (firstInvalidControl.querySelector('.mat-input-element') as HTMLElement)
			if (inputElement) {
				inputElement.focus({
						preventScroll: false
					});
			} else {
				this._scrollToTop();
			}
		} else {
			this._scrollToTop();
		}
	}
	
	private _scrollToTop(): void {
		window.scroll({
			left: 0,
			top: 0,
			behavior: 'smooth'
		});
	}
}
